module.exports = __webpack_public_path__ + "img/202307_03.aa6cc4cb.jpg";